import React from 'react';
import PropTypes from 'prop-types';
import svgIcon from 'components/hoc/svgIcon';

const svg = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="67" height="31" viewBox="0 0 67 31">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-169.000000, -127.000000)" style={{ fill: color || 'currentColor' }}>
        <polygon id="Triangle" points="202.5 127 236 158 169 158" />
      </g>
    </g>
  </svg>
);

svg.propTypes = {
  color: PropTypes.string,
};

svg.defaultProps = {
  color: null,
};

export default svgIcon(svg);
